export default __webpack_public_path__ + "static/media/company_3.c65b9fd8.jpg";